import * as React from 'react';
import {Fragment, useState} from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {Avatar, Box, FormControl, Input, InputLabel, Paper} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {LockOutlined} from "@mui/icons-material";
import {avatarStyle, boxStyle, formStyle, paperSignStyle, submitStyle} from "./style"
import {getConfirmationCodeAsync, selectUser, usernameFilled} from "./sessionSlice";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from '../../app/language-switcher/LanguageSwitcher';
import { Warning } from "@mui/icons-material";

export const ForgotPassword = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const dispatch = useAppDispatch();
    const previouslyTypedUsername = useAppSelector(selectUser)

    React.useEffect(() => setUsername(previouslyTypedUsername), [previouslyTypedUsername]);

    const updateUsername = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setUsername(event.target.value);
        dispatch(usernameFilled(event.target.value))
    };
    const handleSubmit = (event: { preventDefault: () => void; }) => {
        event.preventDefault()
        dispatch(getConfirmationCodeAsync(username))
        navigate('/modifier-le-mot-de-passe');
    }
    return (
        <Box sx={boxStyle}>
            <Paper className="paperSign" sx={paperSignStyle}>
                <div style={{position: "relative", top: "-5%", right: "-45%"}}>
                    <LanguageSwitcher />
                </div>
                <Avatar className="avatar" sx={avatarStyle}>
                    <LockOutlined/>
                </Avatar>
                <Fragment>
                    <Typography component="h1" variant="h5">
                        {t('forgotPassword')}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                        <Warning sx={{ fontSize: 20, mt: 0.25 }} color="primary" />
                        <Box>
                          <Typography variant="body2" color="primary" sx={{ fontSize: '0.875rem' }}>
                            {t('multiProductMessage1')}
                          </Typography>
                          <Typography variant="body2" color="primary" sx={{ fontSize: '0.875rem', fontWeight: 'bold', mt: 1 }}>
                            {t('multiProductMessage2')}
                          </Typography>
                        </Box>
                    </Box>
                    <form className="Form" onSubmit={handleSubmit}>
                        <FormControl margin="normal" required fullWidth sx={formStyle}>
                            <InputLabel htmlFor="username"
                                        className="inputLabel">
                                {t('username')}
                            </InputLabel>
                            <Input id="username"
                                   name="username"
                                   autoComplete="username"
                                   autoFocus
                                   value={username}
                                   inputProps={{readOnly: Boolean(previouslyTypedUsername)}}
                                   onChange={updateUsername}/>
                        </FormControl>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className="Submit"
                            sx={submitStyle}
                        >
                            {t('receiveConfirmationCode')}
                        </Button>
                    </form>
                </Fragment>
            </Paper>
        </Box>
    );
}